// @flow
import React, { Component } from 'react'
import ExpandingDropdown from '../AdvertisementsTable/ExpandingDropdown'
import styled, { type StyledComponent } from 'styled-components'
import ErrorText from '../controls/ErrorText'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  padding: 5px;
`
const Buttons: StyledComponent<Object, any, any> = styled.div`
  margin-top: 15px;
  text-align: left;
`
const InputWrapper: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
  position: relative;
`

type Props = {|
  inputName?: string,
  isOpen: boolean,
  value: string,
  errors: Array<string>,
  triggerBlock: any,
  withCurrency?: boolean,
  onChange: Function,
  onDropdownChange: Function,
  onSubmit: Function
|}

const t = {
  cancel: 'Отменить',
  currency: '₽',
  save: 'Сохранить'
}

export default class SingleParamPopup extends Component<Props> {
  render() {
    return (
      <ExpandingDropdown
        isOpen={this.props.isOpen}
        triggerText={this.props.triggerBlock}
        onChange={(isOpen) => this.props.onDropdownChange(isOpen)}
        inlineBlock
      >
        {this.renderPopupContent()}
      </ExpandingDropdown>
    )
  }

  renderPopupContent() {
    return (
      <Wrapper>
        <InputWrapper>
          <input
            className="input-item"
            name={this.props.inputName}
            type="text"
            value={this.props.value || ''}
            onChange={(e) => this.props.onChange(e)}
          />
        </InputWrapper>
        {this.props.withCurrency && t.currency}
        <ErrorText errors={this.props.errors} />
        <Buttons>
          <button className="btn btn-success" onClick={() => this.props.onSubmit()}>
            {t.save}
          </button>{' '}
          <button className="btn btn-default" onClick={() => this.props.onDropdownChange(false)}>
            {t.cancel}
          </button>
        </Buttons>
      </Wrapper>
    )
  }
}
